const ckeditorStyles = {
	definitions: [
		{
			name: 'Título Numerado',
			element: 'h2',
			classes: ['numbered-title'],
		},
		{
			name: 'Paragrafo Numerado',
			element: 'p',
			classes: ['numbered-paragraph'],
		},
		{
			name: 'Contador com Letra',
			element: 'p',
			classes: ['lower-alpha-paragraph'],
		},
		{
			name: 'Automação',
			element: 'p',
			classes: ['automation'],
		},
	],
}

const ckeditorCss = `
			.ck-content {
				counter-reset: title-counter paragraph-counter;
			}

			.ck-content h2 {
				font-size: 24px;
			}

			.ck-content h3 {
				font-size: 18px;
			}

			.ck-content h4 {
				font-size: 16px;
			}

			.numbered-title {
				text-transform: uppercase;
			}

			.numbered-title::before {
				counter-increment: title-counter;
				content: counter(title-counter, upper-roman) ". ";
			}

			.numbered-paragraph::before {
				counter-increment: paragraph-counter;
				content: counter(paragraph-counter) ". ";
			}

			.lower-alpha-paragraph::before {
				counter-increment: paragraph-counter;
				content: counter(paragraph-counter, lower-alpha) ". ";
			}

			.automation {
				background-color: lightblue;
			}
		`

// Because of some inefficiency in the way the html is structured around CKEditor
//  in the DocumentDetail page and in the EditTemplate page,
// it was necessary to ajust ck editor differently for each page.

const resizableCkeditorStylesForDocumentDetail = `
.ck.ck-reset.ck-editor {
	height:100%;
	max-width: 820px;
}

.ck.ck-editor__main {
	height: calc(100% - 40px);
}

.ck.ck-content.ck-editor__editable.ck-editor__editable_inline {
	height: 100%;
	padding: 0 10px;
}

`

const resizableCkeditorStylesForEditTemplate = `
	.ck.ck-reset.ck-editor {
		height:100%;
	}

	.ck.ck-editor__main {
		height: calc(100% - 89px);
	}

	.ck.ck-content.ck-editor__editable.ck-editor__editable_inline {
		height: 100%;
		padding: 0 50px;
	}
	`

export {
	ckeditorStyles,
	ckeditorCss,
	resizableCkeditorStylesForEditTemplate,
	resizableCkeditorStylesForDocumentDetail,
}
